/**
 * Constantes para el módulo de tipos de movimiento
 */

// Configuración de paginación
export const ITEMS_PER_PAGE = 10;

// Estado inicial de un tipo de movimiento
export const INITIAL_MOVEMENT_TYPE_STATE = {
  description: '',
  nature: 'debit',
  display_in_orders: false,
  is_bank_movement_type: true,
};

// Opciones para el selector de naturaleza
export const NATURE_OPTIONS = [
  { value: 'debit', label: 'Débito (Salidas)' },
  { value: 'credit', label: 'Crédito (Entradas)' },
];

// Reglas de validación
export const VALIDATION_RULES = {
  REQUIRED_FIELDS: ['description', 'nature'],
  MIN_LENGTHS: {
    description: 1,
  },
  MAX_LENGTHS: {
    description: 100,
  },
};

// Mensajes del sistema
export const MESSAGES = {
  MOVEMENT_TYPE_CREATED: 'Tipo de movimiento creado correctamente',
  MOVEMENT_TYPE_UPDATED: 'Tipo de movimiento actualizado correctamente',
  MOVEMENT_TYPE_DELETED: 'Tipo de movimiento eliminado correctamente',
  ERROR_CREATING: 'Error al crear el tipo de movimiento',
  ERROR_UPDATING: 'Error al actualizar el tipo de movimiento',
  ERROR_DELETING: 'Error al eliminar el tipo de movimiento',
  CONFIRM_DELETE: '¿Confirma que desea eliminar este tipo de movimiento?',
};

// Naturalezas disponibles
export const MOVEMENT_NATURES = {
  DEBIT: 'debit',
  CREDIT: 'credit',
};
